module.exports = __webpack_public_path__ + "img/32.00d8054f.png";